<!--
 * @Author: p_fy
 * @Date: 2019-06-18 08:14:49
 * @LastEditors: pfy
 * @LastEditTime: 2019-09-26 15:20:46
 * @Description: 展示资质认证企业信息。
 -->
<template>
  <div>
    <div class="main-wrap">
      <div style="padding-top: 20px;" class="menu-head">
        <div>
          <span style="color: #be2316;border-bottom: 1px solid;padding: 1rem;cursor: pointer;" @click="apilist">{{ setCompanyShow() }}</span>
        </div>
      </div>

      <div v-if="companyInfo" v-loading="loading">
        <div>
          <el-form
            ref="rulesForm"
            :disabled="true"
            :model="authentication"
            :label-position="'right'"
            label-width="135px"
            style="padding-left: 0rem;padding-right: 2rem;"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="认证类型">
                  <span style="color: #be2316;">{{ setCompanyShow() }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="赞助值">
                  <span style="color: #be2316;">{{ authentication.money ? authentication.money : '0' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="公司logo" prop="companyLogo" class="companyLogoItem">
                  <div v-viewer class="companyLogo">
                    <img :src="companyLogoArr[0] | getImg" onerror="this.src='https://graph.baidu.com/thumb/v3/3277128572,4129418819.jpg';this.onerror=null;">
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="账号" style="margin-bottom: 0px;margin-top: 7px;">
                  <span>{{ userInfo.userName }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="公司名称" prop="companyName">
                  <el-input v-model="authentication.companyName" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="统一社会信用代码" prop="taxpayerNumber">
                  <el-col v-if="(companyShow ) && submitCard && (authentication.authStatus !=null && authentication.authStatus != '2')" :span="21" style="padding-left: 0px;padding-right: 0px;">
                    <el-input v-model="authentication.taxpayerNumber" :disabled="!(authentication.authStatus !=null && authentication.authStatus != '2' && authentication.authStatus != '5')" />
                  </el-col>
                  <el-input v-else v-model="authentication.taxpayerNumber" :disabled="!(authentication.authStatus !=null && authentication.authStatus != '2' && authentication.authStatus != '5')" />
                  <el-col v-if="(companyShow ) && submitCard && (authentication.authStatus !=null && authentication.authStatus != '2')" class="line" :span="3" style="text-align: center;font-size: smaller;padding-left:0px;padding-right: 0px;"><a href="JavaScript:void(0);" class="sfSty" @click="appealAchieve">申诉</a></el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="联系人" prop="companyContact">
                  <el-input v-model="authentication.companyContact" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="contactTel">
                  <el-input v-model="authentication.contactTel" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="公司固话" prop="companyTel">
                  <el-input v-model="authentication.companyTel" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="银行账户" prop="bankAccount">
                  <el-input v-model="authentication.bankAccount" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="开户行" prop="openingBank">
                  <el-input v-model="authentication.openingBank" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="营业年限" prop="businessYears">
                  <el-select v-model="authentication.businessYears" placeholder="" class="checkboxSty">
                    <el-option v-for="city in authenType.businessDuration" :key="city.label" :label="city.label" :value="city.value" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 运力方--开始 -->
            <div v-if="userType == '2'">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="运输范围" prop="transportRange">
                    <el-select v-model="authentication.transportRange" placeholder="" class="checkboxSty">
                      <el-option v-for="city in authenType.transportRange" :key="city.label" :label="city.label" :value="city.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="运输方式" prop="transportMode">
                    <el-checkbox-group v-model="authentication.transportMode">
                      <el-checkbox v-for="city in authenType.transportType" :key="city.label" :label="city.value">{{ city.label }}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="自有车辆" prop="ownedVehicle">
                    <el-select v-model="authentication.ownedVehicle" placeholder="" class="checkboxSty">
                      <el-option v-for="city in authenType.ownedVehicle" :key="city.label" :label="city.label" :value="city.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="信息化情况" prop="informatization">
                    <el-select v-model="authentication.informatization" placeholder="" class="checkboxSty">
                      <el-option v-for="city in authenType.informatization" :key="city.label" :label="city.label" :value="city.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <!-- 运力方--结束 -->
            <!-- 仓储方--开始 -->
            <div v-if="userType == '3'">
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="仓库类型" prop="warehouseType">
                    <el-checkbox-group v-model="authentication.warehouseType" @change="typeSel">
                      <el-checkbox v-for="city in authenType.authenticationType" :key="city.label" :label="city.value">{{ city.label }}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="可储存类型" prop="storageType">
                    <el-checkbox-group v-if="authentication.warehouseType == '1'" v-model="authentication.storageType">
                      <el-checkbox v-for="city in authenType.storageType" :key="city.label" :label="city.value">{{ city.label }}</el-checkbox>
                    </el-checkbox-group>
                    <el-checkbox-group v-if="authentication.warehouseType == '2'" v-model="authentication.storageType">
                      <el-checkbox v-for="city in authenType.tankType" :key="city.label" :label="city.value">{{ city.label }}</el-checkbox>
                    </el-checkbox-group>
                    <el-checkbox-group v-if="authentication.warehouseType == '1,2' || authentication.warehouseType == '2,1'" v-model="authentication.storageType">
                      <el-checkbox v-for="city in authenType.attestationStorageType" :key="city.label" :label="city.value">{{ city.label }}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="罐区容积" prop="casingVolume">
                    <el-input v-model="authentication.casingVolume" :disabled="kqrjDisabled">
                      <template slot="append">m³</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="储罐数量" prop="tanksCount">
                    <el-input v-model="authentication.tanksCount" :disabled="cgslDisabled" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="自有仓库面积" prop="owendStorageArea">
                    <el-select v-model="authentication.owendStorageArea" placeholder="" class="checkboxSty" :disabled="zyDisabled">
                      <el-option v-for="city in authenType.owendStorageArea" :key="city.label" :label="city.label" :value="city.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="信息化情况" prop="informatization">
                    <el-select v-model="authentication.informatization" placeholder="" class="checkboxSty">
                      <el-option v-for="city in authenType.informatization" :key="city.label" :label="city.label" :value="city.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <!-- 仓储方--结束 -->
            <div v-if="userType == '2' || userType == '3'">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="电子运单管理" prop="electronicWaybillManagement">
                    <el-select v-model="authentication.electronicWaybillManagement" placeholder="" class="checkboxSty">
                      <el-option v-for="city in authenType.electronicWaybillManagement" :key="city.label" :label="city.label" :value="city.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="客户查询系统" prop="customerInquirySystem">
                    <el-select v-model="authentication.customerInquirySystem" placeholder="" class="checkboxSty">
                      <el-option v-for="city in authenType.CustomerEnquirySystem" :key="city.label" :label="city.label" :value="city.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="主营业务" prop="mainBusiness">
                  <el-input v-model="authentication.mainBusiness" type="textarea" :rows="6" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="公司地址" prop="companyAddress">
                  <el-cascader
                    v-model="authentication.companyAddress"
                    :options="area"
                    :filterable="true"
                    :props="{ expandTrigger: 'hover' ,
                              checkStrictly: true}"
                    style="width: 100%;"
                    class="companyAddress"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="详细地址" class="detailsAddress" prop="detailsAddress">
                  <el-autocomplete
                    v-model="authentication.detailsAddress"
                    popper-class="my-autocomplete"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入内容"
                    style="width: 100%;"
                    @select="handleSelect"
                  >
                    <template slot-scope="{ item }">
                      <div class="name">{{ item.value }}</div>
                      <!--<span class="addr">{{ item.address }}</span>-->
                    </template>
                  </el-autocomplete>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="营业执照" prop="licenseUrl">
                  <div v-viewer class="companyUrl">
                    <img :src="licenseUrlArr[0] | getImg" onerror="this.src='https://graph.baidu.com/thumb/v3/3277128572,4129418819.jpg';this.onerror=null;">
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="银行开户许可证" prop="permitUrl">
                  <div v-viewer class="companyUrl">
                    <img :src="permitUrlArr[0] | getImg" onerror="this.src='https://graph.baidu.com/thumb/v3/3277128572,4129418819.jpg';this.onerror=null;">
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <div v-if="userType == '2'">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车辆运营证" prop="vehicleOperationUrl">
                    <div v-viewer class="companyUrl">
                      <img :src="vehicleOperationUrlArr[0] | getImg" onerror="this.src='https://graph.baidu.com/thumb/v3/3277128572,4129418819.jpg';this.onerror=null;">
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="道路运输许可证" prop="roadTransportUrl">
                    <div v-viewer class="companyUrl">
                      <img :src="roadTransportUrlArr[0] | getImg" onerror="this.src='https://graph.baidu.com/thumb/v3/3277128572,4129418819.jpg';this.onerror=null;">
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="安全运输许可证" prop="safeTransportUrl">
                    <div v-viewer class="companyUrl">
                      <img :src="safeTransportUrlArr[0] | getImg" onerror="this.src='https://graph.baidu.com/thumb/v3/3277128572,4129418819.jpg';this.onerror=null;">
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

            <el-row v-if="submitCard" :gutter="20">
              <el-col :span="12">
                <el-form-item label="">
                  <span style="color: #be2316;">注：</span>
                  <span>*均为必填项</span>
                </el-form-item>
              </el-col>
            </el-row>
            <div v-if="submitCard">
              <el-button
                class="el-button-ml"
                type="danger"
                round
                @click="modifiedAuthentication('rulesForm')"
              >提交</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div></template>
<script type="text/ecmascript-6">
import AMap from 'AMap' // 引入高德地图
import { mapGetters } from 'vuex'
// 引用数据
import { getUserInfo, getDict, getArea } from '@/api/personal/user/qualifications-authen/authentication'
import { tableClass } from '@/api/personal/user/qualifications-authen/AuthenticationParam' // 仓储方表格、表单参数列表
const param = tableClass.getData() // 引用表格参数类(包含查询条件的表单)
import { DatabaseUtil } from '@/utils/databaseUtils'
const dataBase = new DatabaseUtil()
export default {
  name: 'CompanyInfo',
  components: { },
  computed: {
    ...mapGetters(['roles', 'userType', 'name', 'userInfo']),
    companyLogoArr() { // 企业Log图片回调
      if (this.authentication.companyLogo == null || this.authentication.companyLogo == '') {
        return false
      }
      return this.authentication.companyLogo.split(',').filter(n => n) // 数组去空
    },
    licenseUrlArr() { // 营业执照图片回调
      if (this.authentication.licenseUrl == null || this.authentication.licenseUrl == '') {
        return false
      }
      return this.authentication.licenseUrl.split(',').filter(n => n) // 数组去空
    },
    permitUrlArr() { // 银行开户许可证图片回调
      if (this.authentication.permitUrl == null || this.authentication.permitUrl == '') {
        return false
      }
      return this.authentication.permitUrl.split(',').filter(n => n) // 数组去空
    },
    vehicleOperationUrlArr() { // 车辆营运证图片回调
      if (this.authentication.vehicleOperationUrl == null || this.authentication.vehicleOperationUrl == '') {
        return false
      }
      return this.authentication.vehicleOperationUrl.split(',').filter(n => n) // 数组去空
    },
    roadTransportUrlArr() { // 道路运输许可证图片回调
      if (this.authentication.roadTransportUrl == null || this.authentication.roadTransportUrl == '') {
        return false
      }
      return this.authentication.roadTransportUrl.split(',').filter(n => n) // 数组去空
    },
    safeTransportUrlArr() { // 安全运输许可证图片回调
      if (this.authentication.safeTransportUrl == null || this.authentication.safeTransportUrl == '') {
        return false
      }
      return this.authentication.safeTransportUrl.split(',').filter(n => n) // 数组去空
    }

  },
  data() {
    return {
      ...param, // 定义属性元素引用
      companyInfo: true,
      authenticationFile: '',
      loading: true, // 预加载样式
      area: [],
      authenType: {
        businessDuration: [], // 营业年限
        transportRange: [], // 运输范围
        transportType: [], // 运输方式
        ownedVehicle: [], // 自有车辆
        informatization: [], // 信息化情况
        authenticationType: [], // 资质认证仓库类型
        attestationStorageType: [], // 可存储类型
        storageType: [], // 仓库储存类型
        tankType: [], // 罐区储存类型
        owendStorageArea: [], // 自有仓面积
        electronicWaybillManagement: [], // 电子运单管理
        CustomerEnquirySystem: [] // 客户查询系统
      }
    }
  },
  watch: {
    '$route'(to, from) { // 监听刷新页面
      if (to.name == 'QualificationsAuthen') {
        this.apilist()
      }
    }
  },
  // 初始化加载 所有资格认证数据
  created() {
    // 获取消息通知过来的数据
    if (this.$route.params.noticeId != undefined) {
      // console.log('消息通知过来的数据', 'id:' + this.$route.params.noticeId, 'type:' + this.$route.params.noticeMark)
    }
    (async() => {
      await this.getArea()
      await this.getBusinessDuration()
      await this.getTransportRange()
      await this.getTransportType()
      await this.getOwnedVehicle()
      await this.getInformatization()
      await this.getAuthenticationType()
      await this.getStorageType()
      await this.getTankType()
      await this.getAttestationStorageType()
      await this.getOwendStorageArea()
      await this.getElectronicWaybillManagement()
      await this.getCustomerEnquirySystem()
      this.apilist()
    })()
  },
  methods: {
    getLocalStorageUtil(name) {
      return new Promise((resolve, reject) => {
        if (dataBase.localStorageUtil.has(name)) {
          resolve(JSON.parse(dataBase.localStorageUtil.get(name)))
        } else {
          reject(name)
        }
      })
    },
    setLocalStorageUtil(name, result) {
      dataBase.localStorageUtil.set(name, JSON.stringify(result))
    },
    // 详情位置回调
    handleSelect(item) {
      // console.log(item)
    },
    // 地图定位查询
    querySearch(queryString, cb) {
      const addres = this.authentication.companyAddress
      if (addres == null || addres == '') {
        var isError = document.getElementsByClassName('companyAddress')
        this.authentication.detailsAddress = ''
        isError[0].querySelector('input').focus()
        cb([])
        this.$message({
          message: '请先选择公司地址!',
          offset: 100,
          type: 'warning'
        })
        // this.isErrorShow('请先选择公司地址!')
        return
      }
      if (queryString == null || queryString == '') {
        cb([])
        return
      }
      var results = []
      // const map = this.map
      AMap.service(['AMap.PlaceSearch'], () => {
      // 构造地点查询类
        const placeSearch = new AMap.PlaceSearch({
          pageSize: 5, // 单页显示结果条数
          pageIndex: 1, // 页码
          // city: '邹平', // 兴趣点城市
          city: addres[addres.length - 1],
          citylimit: true // 是否强制限制在设置的城市内搜索
          // map: map // 展现结果的地图实例
        // panel: 'panel', // 结果列表将在此容器中进行展示。
        // autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
        })
        // 关键字查询
        placeSearch.search(queryString, (status, result) => {
          if (status == 'complete') {
            result.poiList.pois.forEach(element => {
              results.push({ 'title': element.name, 'value': element.address + element.name, 'address': element.name, 'location': element.location })
            })
            cb(results)
          } else {
            this.authentication.detailsAddress = ''
            cb(results)
            this.$message({
              message: '暂无数据!',
              offset: 100,
              type: 'warning'
            })
            // this.isErrorShow('暂无数据!')
            // cb(results)
          }
        })
      })
    },
    // 详情地址错误提示
    isErrorShow(errName) {
      setTimeout(function() {
        var isDetailsError = document.getElementsByClassName('detailsAddress')
        var detaError = isDetailsError[0].querySelector('.el-form-item__error')
        if (!detaError) {
          var autocomplete = isDetailsError[0].querySelector('.el-form-item__content')
          var btn = document.createElement('div')
          var att = document.createAttribute('class')
          att.value = 'el-form-item__error'
          btn.setAttributeNode(att)
          var t = document.createTextNode(errName)
          btn.appendChild(t)
          autocomplete.appendChild(btn)
          // var t=document.createTextNode("CLICK ME");
        } else {
          detaError.innerHTML = errName
        }
      }, 100)
    },
    // 地址字典
    getArea() {
      this.getLocalStorageUtil('area').then((data) => {
        this.area = data
      }).catch(() => {
        getArea()
          .then(data => {
            this.area = data.result
            this.setLocalStorageUtil('area', data.result)
          })
          .catch(error => {
            console.error(error)
          })
      })
    },
    // 营业年限字典
    getBusinessDuration() {
      this.getLocalStorageUtil('businessDuration').then((businessDuration) => {
        if (businessDuration.length > 0) {
          businessDuration.forEach(res => {
            this.authenType.businessDuration.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('businessDuration').then(res => {
          const businessDuration = JSON.parse(res.result)
          this.setLocalStorageUtil('businessDuration', businessDuration)
          if (businessDuration.length > 0) {
            businessDuration.forEach(res => {
              this.authenType.businessDuration.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 运输范围字典
    getTransportRange() {
      this.getLocalStorageUtil('transportRange').then((transportRange) => {
        if (transportRange.length > 0) {
          transportRange.forEach(res => {
            this.authenType.transportRange.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('transportRange').then(res => {
          const transportRange = JSON.parse(res.result)
          this.setLocalStorageUtil('transportRange', transportRange)
          if (transportRange.length > 0) {
            transportRange.forEach(res => {
              this.authenType.transportRange.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 运输方式字典
    getTransportType() {
      this.getLocalStorageUtil('transportType').then((transportType) => {
        if (transportType.length > 0) {
          transportType.forEach(res => {
            this.authenType.transportType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('transportType').then(res => {
          const transportType = JSON.parse(res.result)
          this.setLocalStorageUtil('transportType', transportType)
          if (transportType.length > 0) {
            transportType.forEach(res => {
              this.authenType.transportType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 自有车辆字典
    getOwnedVehicle() {
      this.getLocalStorageUtil('ownedVehicle').then((ownedVehicle) => {
        if (ownedVehicle.length > 0) {
          ownedVehicle.forEach(res => {
            this.authenType.ownedVehicle.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('ownedVehicle').then(res => {
          const ownedVehicle = JSON.parse(res.result)
          this.setLocalStorageUtil('ownedVehicle', ownedVehicle)
          if (ownedVehicle.length > 0) {
            ownedVehicle.forEach(res => {
              this.authenType.ownedVehicle.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 信息化情况字典
    getInformatization() {
      this.getLocalStorageUtil('informatization').then((informatization) => {
        if (informatization.length > 0) {
          informatization.forEach(res => {
            this.authenType.informatization.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('informatization').then(res => {
          const informatization = JSON.parse(res.result)
          this.setLocalStorageUtil('informatization', informatization)
          if (informatization.length > 0) {
            informatization.forEach(res => {
              this.authenType.informatization.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 资质认证仓库类型字典
    getAuthenticationType() {
      this.getLocalStorageUtil('authenticationType').then((authenticationType) => {
        if (authenticationType.length > 0) {
          authenticationType.forEach(res => {
            this.authenType.authenticationType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('authenticationType').then(res => {
          const authenticationType = JSON.parse(res.result)
          this.setLocalStorageUtil('authenticationType', authenticationType)
          if (authenticationType.length > 0) {
            authenticationType.forEach(res => {
              this.authenType.authenticationType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 可存储类型字典
    getAttestationStorageType() {
      this.getLocalStorageUtil('attestationStorageType').then((attestationStorageType) => {
        if (attestationStorageType.length > 0) {
          attestationStorageType.forEach(res => {
            this.authenType.attestationStorageType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('attestationStorageType').then(res => {
          const attestationStorageType = JSON.parse(res.result)
          this.setLocalStorageUtil('attestationStorageType', attestationStorageType)
          if (attestationStorageType.length > 0) {
            attestationStorageType.forEach(res => {
              this.authenType.attestationStorageType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 储存类型字典
    getStorageType() {
      this.getLocalStorageUtil('storageType').then((storageType) => {
        if (storageType.length > 0) {
          storageType.forEach(res => {
            this.authenType.storageType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('storageType').then(res => {
          const storageType = JSON.parse(res.result)
          this.setLocalStorageUtil('storageType', storageType)
          if (storageType.length > 0) {
            storageType.forEach(res => {
              this.authenType.storageType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 罐区储存类型字典
    getTankType() {
      this.getLocalStorageUtil('tankType').then((tankType) => {
        if (tankType.length > 0) {
          tankType.forEach(res => {
            this.authenType.tankType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('tankType').then(res => {
          const tankType = JSON.parse(res.result)
          this.setLocalStorageUtil('tankType', tankType)
          if (tankType.length > 0) {
            tankType.forEach(res => {
              this.authenType.tankType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 自有仓面积字典
    getOwendStorageArea() {
      this.getLocalStorageUtil('owendStorageArea').then((owendStorageArea) => {
        if (owendStorageArea.length > 0) {
          owendStorageArea.forEach(res => {
            this.authenType.owendStorageArea.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('owendStorageArea').then(res => {
          const owendStorageArea = JSON.parse(res.result)
          this.setLocalStorageUtil('owendStorageArea', owendStorageArea)
          if (owendStorageArea.length > 0) {
            owendStorageArea.forEach(res => {
              this.authenType.owendStorageArea.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 电子运单管理字典
    getElectronicWaybillManagement() {
      this.getLocalStorageUtil('electronicWaybillManagement').then((electronicWaybillManagement) => {
        if (electronicWaybillManagement.length > 0) {
          electronicWaybillManagement.forEach(res => {
            this.authenType.electronicWaybillManagement.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('electronicWaybillManagement').then(res => {
          const electronicWaybillManagement = JSON.parse(res.result)
          this.setLocalStorageUtil('electronicWaybillManagement', electronicWaybillManagement)
          if (electronicWaybillManagement.length > 0) {
            electronicWaybillManagement.forEach(res => {
              this.authenType.electronicWaybillManagement.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 客户查询系统字典
    getCustomerEnquirySystem() {
      this.getLocalStorageUtil('CustomerEnquirySystem').then((CustomerEnquirySystem) => {
        if (CustomerEnquirySystem.length > 0) {
          CustomerEnquirySystem.forEach(res => {
            this.authenType.CustomerEnquirySystem.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('CustomerEnquirySystem').then(res => {
          const CustomerEnquirySystem = JSON.parse(res.result)
          this.setLocalStorageUtil('CustomerEnquirySystem', CustomerEnquirySystem)
          if (CustomerEnquirySystem.length > 0) {
            CustomerEnquirySystem.forEach(res => {
              this.authenType.CustomerEnquirySystem.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 跳转员工管理頁面
    OpenStaff() {
      this.$router.push({ name: 'Staff' })
    },
    // 跳转申诉页面
    appealAchieve() {
      this.$router.push({
        name: 'Appeal',
        params: {
        }
      })
    },
    // 初始化头部信息
    failShow(item, index) {
      return `${index + 1}.${this.failContent[item - 1]}`
    },
    // 公司类型转换
    setCompanyShow() {
      if (this.userType != null) {
        this.authenticationFile = this.companyTypefile[this.userType]
        return this.companyTypeName[this.userType]
      } else {
        return ''
      }
    },
    // 储存权限控制
    typeSel(val) {
      this.authentication.storageType == ''
      if (val == null) {
        return false
      }
      if (val.length <= 0) {
        this.typeDisplay(true, true, true, true)
      } else if (val.length >= 2) {
        this.typeDisplay(false, false, false, false)
      } else {
        if (val[0] == '1') {
          this.typeDisplay(false, false, true, false)
        }
        if (val[0] == '2') {
          this.typeDisplay(true, true, false, false)
        }
      }
    },
    // 储存类型权限内容控制
    typeDisplay(kqrj, cgsl, zy, yy) {
      this.kqrjDisabled = kqrj
      this.cgslDisabled = cgsl
      this.zyDisabled = zy
      this.yyDisabled = yy
    },
    // 根据Uid查询当前认证状态
    apilist() {
      this.loading = true
      getUserInfo({ userId: null }).then(res => {
        // 打印输出
        if (res.result != null) {
          this.companyInfo = true
          this.authentication = res.result
          this.authentication.warehouseType = !res.result.warehouseType ? [] : res.result.warehouseType.split(',')
          this.authentication.storageType = !res.result.storageType ? [] : res.result.storageType.split(',')
          this.authentication.transportMode = !res.result.transportMode ? [] : res.result.transportMode.split(',')
          this.authentication.returnReasons = !res.result.returnReasons ? [] : res.result.returnReasons.split(',')
          this.authentication.companyAddress = !res.result.companyAddress ? [] : res.result.companyAddress.split('#')
          this.typeSel(this.authentication.warehouseType)
          console.log(res.result)
        } else {
          this.companyInfo = true
        }
        if (res.user != null) {
          this.user = res.user
        }
        this.loading = false
        return
      }).catch((err) => {
        console.log(err)
        this.loading = false
        this.companyInfo = true
      })
    }
  }
}
</script>
<style scoped lang='scss'>
  @import "@/styles/standardColor.scss";
   // 上传图片js
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  // 前面都是上传
  .intenal-box {
    width: 100%;
    height: 100%;
    padding: 50px 0px;
  }

    .upload-icon{
    margin: auto auto;
    width: 100%;
    line-height: 24px;
  }
  .upload-info-text{
    margin: auto auto;
    width: 100%;
    line-height: 50px;
  }

    /deep/ .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before  {
    content: '*';
    color: #be2316;
    font-size: 16px;
    margin-right: 4px;
  }
  input__inner {
    background-color: white;
    border-radius: 0px;
    border: 0;
    border-bottom: 1px solid gainsboro;
  }
  /deep/.el-input input{
    border-radius:0px;
  }
  /deep/.checkboxSty .el-input .el-input__inner , /deep/.el-textarea .el-textarea__inner{
    border-radius:0px;
  }
  /deep/.el-form-item {
    margin-bottom: 20px;
  }
  /deep/.checkboxSty{
    width:100%;
  }
  /deep/.sfSty{
    color:#409EFF
  }
  /deep/.sfSty:hover{
    color: #8c939d
  }
  /deep/.el-card .el-card__body{
    display: grid;
    padding: 4rem;
  }
  /deep/.companyLogoItem .companyLogo{
    width: 4rem;
    height: 4rem;
    line-height: 73px;
  }
  /deep/.companyLogoItem .companyLogo img{
    width: 100%;
    height: 100%;
  }
  /deep/.companyLogoItem .el-upload-list--picture-card .el-upload-list__item{
    width: 4rem;
    height: 4rem;
  }
  /deep/.companyUrl{
    width: 10rem;
    height: 10rem;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .el-button-ml{
    margin-left: 35%;
    width: 35%;
    height: 40px;
    margin-top: 50px;
    font-size: 18px;
    background-color: #BE2316;
    margin-bottom: 10%
  }
  .menu-head {
    display: flex;
    margin: 1rem;
    padding-bottom: 1rem;
    border-style: dashed;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    .head-color {
      width: 5px;
      height: 18px;
      background-color: #be2316;
      border-radius: 5px;
      margin-right: 1rem;
    }
    font-size: 18px;
    font-weight: bold;
  }
  .main-wrap{
    width: 100%;
    background-color: white;
    margin-top: -15px;
  }
</style>
